import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3.5),
    boxShadow: theme.shadows[1],
    marginBottom: theme.spacing(2),
  },
}));
